import { frameNr } from '.';
import logger from './controllers/logger';
import { getEntityPositionXY, getEntityState } from './entity';
import { hasVisibleState, magnitudeSqrXY, scaleV2 } from './helpers';
import { ObjectType } from './shared/api_shared_types';

import { Entity, GameObject, Shape, V2 } from './types';

export type InterActionProps = {
  allowHighlight: boolean;
  allowClick: boolean;
  mouseIsDown: boolean;
  mouseDownThisFrame: boolean;
  mouseUpThisFrame: boolean;
};

export function setEntityHierarchyInteraction(
  parent: GameObject,
  relativePos: V2,
  scale: number,
  allowHighlightOverride: boolean = true,
): Entity {
  let topEntity: Entity = null;

  const children = parent.children;

  scale *= parent.scale;
  parent.relativeMousePos = scaleV2(relativePos, 1 / scale);

  parent.mouseOver = isInEntityShapeNew(
    parent,
    parent.scale,
    parent.relativeMousePos.x,
    parent.relativeMousePos.y,
  );

  let topHighlightedChild: Entity = null;

  if (!parent.doClipChildren || parent.mouseOver) {
    for (let i = children.length - 1; i >= 0; i--) {
      const child = children[i];

      const state = getEntityState(child);
      if (!hasVisibleState(state)) {
        continue;
      }

      const [x, y] = getEntityPositionXY(child);
      const scaledEntPosX = x * scale;
      const scaledEntPosY = y * scale;
      const childRelativePosX = relativePos.x - scaledEntPosX;
      const childRelativePosY = relativePos.y - scaledEntPosY;

      // child.mouseOver = isInEntityShapeNew(child, scale, childRelativePosX, childRelativePosY);

      const childsTopEntity = setEntityHierarchyInteraction(
        child,
        { x: childRelativePosX, y: childRelativePosY },
        scale,
        child.allowChildHighlight,
      );

      if (allowHighlightOverride) {
        child.topHighlightedChild = childsTopEntity;
      }

      if (allowHighlightOverride) {
        if (!topHighlightedChild || child.localZIndex > topHighlightedChild.localZIndex) {
          if (child.topHighlightedChild) {
            topEntity = child.topHighlightedChild;
            topHighlightedChild = child;
          } else if (child.mouseOver && child.allowHighlight) {
            topEntity = child;
            topHighlightedChild = child;
          }
        }
      }
    }
  }

  if (parent.objectType === ObjectType.CANVAS) {
  } else if (parent.objectType === ObjectType.BREAKOUT_CONTROLLER) {
  }

  if (parent.objectType === ObjectType.CANVAS) {
    parent.manager.cursor.highlightCanvasses.push(parent);
  }

  return topEntity;
}

function isInEntityShapeNew(ent: Entity, scale: number, posX: number, posY: number): boolean {

  const s = ent.scale * scale;

  if (ent.shape === Shape.CIRCLE) {
    let radiusSqr = ent.radius * s * ent.radius * s;
    let posMag = magnitudeSqrXY(posX, posY);

    return posMag < radiusSqr;
  } else {
    const marginLeft = -ent.width * ent.pivotPoint.x * s;
    const marginRight = ent.width * (1 - ent.pivotPoint.x) * s;
    const marginTop = -ent.height * ent.pivotPoint.y * s;
    const marginBottom = ent.height * (1 - ent.pivotPoint.y) * s;


    return posX >= marginLeft && posX <= marginRight && posY >= marginTop && posY <= marginBottom;
  }
}
